var _defs, _mask, _path, _defs2, _mask2, _path2, _defs3, _mask3, _polyline, _path3, _polyline2, _polyline3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLennoxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 14",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Lennox Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 11.2,
    y: 0.1,
    width: 36.6,
    height: 13.9,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    x: 11.2,
    y: 0.1,
    width: 36.6,
    height: 13.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "LennoxSt0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "LennoxSt1",
    points: "0 0.1 47.8 0.1 47.8 14 0 14"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "LennoxSt2",
    d: "m39.7 13.2c-7.6 1.7-17.6 0-17.6 0s23.1 2.2 22.5-6.5c-0.6-8.8-33.4-5.1-33.4-5.1 20.1-3.2 29.3-0.2 30 0 3.8 1 6.3 2.9 6.5 5 0.7 3.7-4.5 5.9-8 6.6"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 24.7,
    y: 3,
    width: 7.4,
    height: 8.4,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: 24.7,
    y: 3,
    width: 7.4,
    height: 8.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "LennoxSt3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "LennoxSt1",
    points: "0 0.1 47.8 0.1 47.8 14 0 14"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "LennoxSt4",
    d: "m30.8 5c0.1-0.3 0.2-0.6 0-0.9-0.1-0.2-0.3-0.2-0.5-0.2h-0.7c-0.4 0-0.6 0.1-0.8 0.2-0.2 0.2-0.3 0.3-0.5 0.9l-1.4 4.3c-0.1 0.4-0.1 0.7 0 0.9s0.4 0.3 0.9 0.3 0.9 0 1.3-0.3c0.2-0.1 0.3-0.4 0.5-0.8l1.2-4.4zm-4.3 6.4c-0.8 0-1.3-0.2-1.6-0.5-0.3-0.4-0.3-0.9-0.1-1.6l1.3-4.1c0.3-0.9 0.6-1.4 1.1-1.7 0.4-0.3 1.1-0.4 2-0.4h0.9c0.9 0 1.3 0.1 1.7 0.5 0.3 0.3 0.3 0.8 0 1.7l-1.3 4.1c-0.2 0.7-0.5 1.3-1 1.7s-1.3 0.5-2 0.5h-1v-0.2z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 0,
    y: 3.1,
    width: 5,
    height: 8.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 3.1,
    width: 5,
    height: 8.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "LennoxSt5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "LennoxSt1",
    points: "0 0.1 47.8 0.1 47.8 14 0 14"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "LennoxSt6",
    points: "4.7 11.2 0 11.2 2.7 3.1 4.6 3.1 2.3 10.3 5 10.3 4.7 11.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "LennoxSt7",
    d: "m12.7 3.9l0.3-0.9h-4.5l-2.5 8h4.4l0.3-0.9h-2.5s0.5-1.5 1-3.1h2.2l0.3-0.9s-1.2 0-2.2 0c0.3-0.8 0.5-1.6 0.7-2.2h2.5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "LennoxSt7",
    points: "24.9 3 23.2 8.4 22.5 3 20.6 3 18 11 19.9 11 21.6 5.6 22.3 11 22.3 11 23.4 11 26 3 24.9 3"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "LennoxSt7",
    points: "39 3 37.6 3 36 5.1 35.6 3 33.5 3 34.3 6.6 31 11 32.4 11 34.6 8 35.2 11 37.1 11 36.3 6.5 39 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "LennoxSt7",
    d: "m17.9 3l-1.7 5.4-0.7-5.4h-1.9l-2.6 8h1.9l1.7-5.4s0.7 5.3 0.7 5.4h1.1l2.6-8h-1.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "LennoxSt7",
    d: "m43.5 13.5c0.1 0 0.2 0 0.2-0.1 0 0 0-0.1-0.1-0.1h-0.1v0.2zm-0.1-0.3h0.2c0.1 0 0.2 0.1 0.2 0.1 0 0.1-0.1 0.1-0.1 0.2l0.1 0.2h-0.1l-0.1-0.2h-0.1v0.2h-0.1v-0.5zm-0.3 0.3c0 0.2 0.2 0.4 0.4 0.4s0.4-0.2 0.4-0.4-0.2-0.4-0.4-0.4-0.4 0.2-0.4 0.4zm0.9 0c0 0.3-0.2 0.5-0.5 0.5s-0.5-0.2-0.5-0.5 0.2-0.5 0.5-0.5 0.5 0.2 0.5 0.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLennoxLogo);
export default __webpack_public_path__ + "static/media/lennox-logo.671a1b8f5718da9082b1bea29718e4c9.svg";
export { ForwardRef as ReactComponent };